var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.storeInfo.storeTypeCd == '800900000000')?_c('div',[_c('index-dev')],1):_vm._e(),(_vm.storeInfo.storeTypeCd == '800900000001')?_c('div',[_c('index-admin')],1):_vm._e(),(_vm.storeInfo.storeTypeCd == '800900000005')?_c('div',[_c('index-shop')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }